import { useAxiosInstance } from "./axiosInstance";

export const useCleanSession = () => {
  const axiosInstance = useAxiosInstance();

  const fetchActiveCleaningSessions = async () => {
    const axiosInstanceResolved = await axiosInstance;
    return axiosInstanceResolved.get("/cleaning-sessions?status=in_progress");
  };

  const fetchAllCleaningSessions = async () => {
    const axiosInstanceResolved = await axiosInstance;
    return axiosInstanceResolved.get("/cleaning-sessions");
  };

  const fetchAllCleaningSessionsWithChecklists = async () => {
    const axiosInstanceResolved = await axiosInstance;
    return axiosInstanceResolved.get(
      "/cleaning-sessions?include_checklist=true"
    );
  };

  const startCleaningSession = async (roomId, cleanerId, notes = "") => {
    const instance = await axiosInstance;
    return instance.post("/cleaning-sessions/start", {
      room_id: roomId,
      cleaner_id: cleanerId,
      notes,
    });
  };

  const completeCleaningSession = async (sessionId, notes = "") => {
    const instance = await axiosInstance;
    return instance.post(`/cleaning-sessions/${sessionId}/complete`, {
      notes,
    });
  };

  const addSupervisorComment = async (sessionId, comment) => {
    const instance = await axiosInstance;
    return instance.post(`/cleaning-sessions/${sessionId}/supervisor-comment`, {
      comment,
    });
  };

  return {
    fetchActiveCleaningSessions,
    fetchAllCleaningSessions,
    fetchAllCleaningSessionsWithChecklists,
    startCleaningSession,
    completeCleaningSession,
    addSupervisorComment,
  };
};
